import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranscriptAnalysisRun } from '../models/quality.models';
import { LoadingStateComponent } from './loading-state.component';
import { EmptyStateComponent } from './empty-state.component';
import { ErrorStateComponent } from './error-state.component';

@Component({
  selector: 'app-transcript-analysis-runs-widget',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    LoadingStateComponent,
    EmptyStateComponent,
    ErrorStateComponent,
  ],
  templateUrl: './transcript-analysis-runs-widget.component.html',
  styleUrls: ['./transcript-analysis-runs-widget.component.scss'],
})
export class TranscriptAnalysisRunsWidgetComponent {
  @Input() title = '';
  @Input() runs: TranscriptAnalysisRun[] = [];
  @Input() count = 0;
  @Input() responseDays = 7;
  @Input() loading = false;
  @Input() error = '';
  @Output() query = new EventEmitter<{ days: number; limit: number }>();
  days = 7;
  limit = 50;
  selected: TranscriptAnalysisRun | null = null;
  select(run: TranscriptAnalysisRun): void {
    this.selected = this.selected === run ? null : run;
  }
  load(): void {
    this.query.emit({ days: this.days, limit: this.limit });
  }
}
